import { KernelEventBus } from "../bus/event-bus.js";
export class DurableEventDispatcher {
    #bus;
    #now;
    #store;
    #tail = Promise.resolve();
    constructor(store, bus, options = {}) {
        this.#bus = bus;
        this.#now = options.now ?? (() => new Date().toISOString());
        this.#store = store;
    }
    drain() {
        return this.#enqueue(async () => await this.#drainUndelivered());
    }
    start() {
        return this.drain();
    }
    commitAndDrain(commit) {
        return this.#enqueue(async () => {
            const result = await commit();
            await this.#drainUndelivered();
            return result;
        });
    }
    runExclusive(operation) {
        return this.#enqueue(operation);
    }
    #enqueue(operation) {
        const result = this.#tail.then(operation, operation);
        this.#tail = result.then(() => undefined, () => undefined);
        return result;
    }
    async #drainUndelivered() {
        for (;;) {
            const [stored] = await this.#store.listUndelivered();
            if (stored === undefined)
                return;
            await this.#store.markDeliveryAttempt(stored.sequence);
            this.#bus.publishDurable(stored.sequence, stored.event);
            await this.#store.markDelivered(stored.sequence, this.#now());
        }
    }
}
//# sourceMappingURL=durable-event-dispatcher.js.map